<script>
    export let latestQuoteData;
</script>

<div>
    <p class="leading-6">
        Create a fee estimate for this encounter (ID: {latestQuoteData.patientEncounterId})?
    </p>
    <p class="leanding-6">Please note - it will NOT be sent automatically.</p>
</div>

<style>
   
</style>
